export const subscribeQuery = `
query {
  legalInformations {
    newsletter {
      id
      label
      description
      url
      required
      preChecked
    }
    bookingProcess {
      id
      ref
      url
      title
      label
      urlLabel
      description
      required
      preChecked
      concernedAttendees
      type
    }
  }
  newsletters { description id }
  config {
    booking {
      participants {
        labels {
          civility
          email
          firstName
          lastName
        }
        errorMessage {
          legalAgreement
        }
      }
    }
    common {
      form {
        errors {
          requiredField
          validField
          fieldTooLong
        }
      }
    }
    newsletter {
      errorMessages {
        privacyPolicyNotAccepted
      }
      immersiveText
      immersiveBackground
      seo { title description }
      signup {
        civilityFemale
        civilityMale
        confirm
        description
        subscriptions
        mobileNumber
      }
      link { label href }
      confirmation : confirmation {
        href
      }
    }
  }
}
`;
export const unsubscribeQuery = `
  query {
    legalInformations {
      newsletter {
        description
        id
        label
        preChecked
        required
        url
      }
    }
    newsletters { description id }
    config {
      newsletter {
        immersiveText
        immersiveBackground
        seo { description title }
        signup { confirm subscriptions }
        management { description label }
        link { href label }
        confirmationUnsubscription : managementConfirmation { href }
        confirmationSubscription : confirmation { href }
      }
    }
  }
`;

export const getSubscriptionQuery = (subscriptionId) => `query {
  subscriptions(subscriptionId:"${subscriptionId}") {
    list
    email
  }
}`;

export const confirmationSubcriptionQuery = `query {
  config {
    newsletter {
      seo {
        title
      }
      immersiveText
      immersiveBackground
      confirmation {
        headline
        description
      }
      managementConfirmation {
        headline
        description
      }
    }
    common {
      goToHome
    }
  }
}`;
